import type { ChangeEvent } from 'react';
import { Box, Stack, Typography } from '@mui/material';

export type CatalogSearch = {
    label: string;
    placeholder: string;
    value: string;
    onChange: (value: string) => void;
};

export type CatalogHeaderProps = {
    title: string;
    subtitle: string;
    search?: CatalogSearch;
};

/** The top of a catalogue page: its name, one line on what it offers, and an optional search. */
export function CatalogHeader({ title, subtitle, search }: CatalogHeaderProps) {
    function handleSearch(event: ChangeEvent<HTMLInputElement>) {
        search?.onChange(event.target.value);
    }

    return (
        <Stack direction={ { xs: 'column', md: 'row' } } alignItems={ { md: 'flex-end' } } justifyContent="space-between" spacing={ 3 }>
            <Stack spacing={ 0.75 }>
                <Typography component="h1" variant="inherit" sx={ { fontSize: 32, lineHeight: '40px', fontWeight: 800, letterSpacing: '-0.02em' } }>
                    { title }
                </Typography>
                <Typography sx={ { fontSize: 15, color: '#4F5B67' } }>{ subtitle }</Typography>
            </Stack>

            { search && (
                <Stack spacing={ 0.75 } sx={ { width: { xs: '100%', md: 280 } } }>
                    <Box component="label" htmlFor="catalog-search" sx={ { fontSize: 12, fontWeight: 700, color: '#4F5B67' } }>
                        { search.label }
                    </Box>
                    <Box component="input" id="catalog-search" type="search" placeholder={ search.placeholder }
                         value={ search.value } onChange={ handleSearch }
                         sx={ {
                             height: 44, border: '1px solid #CFD6DE', borderRadius: '10px', px: 1.75, font: 'inherit', fontSize: 14,
                             bgcolor: '#FFFFFF', color: '#161C24', boxSizing: 'border-box',
                             '&:focus': { outline: '2px solid #2065D1', outlineOffset: 1 },
                         } }/>
                </Stack>
            ) }
        </Stack>
    );
}
